import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";

import {modifyPageLayoutComponents} from "../PageLayout";
import FeaturesSetupHeader from "./FeaturesSetupHeader";
import FeaturesSetupFooter from "./FeaturesSetupFooter";
import FeaturesSetupTopPanel from "./FeaturesSetupTopPanel";
import {getActiveFeatureGroup} from "../ProjectScope/ProjectScopeSelector";
import FeaturesSetupList from "./FeaturesSetupList";
import {loadFeaturesSetupFeatures} from "./featuresAsyncActions";
import {clearFeaturesSetup, featuresSetupSetSearchTerm, setFeatureCreatorFeatureGroup} from "./featuresActions";
import {clearInitialValues, getCustomerInfo} from "../AddNewEntity/AddNewEntityActions";
import {getAllFilterGroups} from "../FeatureCreator/FeaturesFilters/FeaturesFiltersActions";


const FeaturesSetup = (props) => {

  const {loadFeaturesSetupFeatures, clearFeaturesSetup, group, catId, setFeatureCreatorFeatureGroup,
    getCustomerInfo, clearInitialValues, allFilterGroups} = props;
  const [currentScroll, setCurrentScroll] = useState(0);

  useEffect(() => {
    loadFeaturesSetupFeatures(group, catId);
  }, [group, catId]);

  const loadFeaturesSetupPage = async () => {
    setFeatureCreatorFeatureGroup(group, catId);
    const profile = await getCustomerInfo(null, "Fabricator", "undefined", false);
    if (profile.useDifferentCurrencies && !allFilterGroups.length) {
      getAllFilterGroups();
    }
  }

  useEffect(() => {
    loadFeaturesSetupPage();
    return () => {
      clearInitialValues();
      clearFeaturesSetup()
    }
  }, [])

  return (
    <div className="fs">
      <FeaturesSetupTopPanel group={group} currentScroll={currentScroll}/>
      <FeaturesSetupList setCurrentScroll={setCurrentScroll}/>
    </div>
  )
};

const mapStateToProps = (store, ownProps) => {
  const {location} = ownProps;
  const {allFilterGroups} = store.featuresFiltersState;

  return {
    catId: location.query.catId,
    group: location.query.group,
    activeFeatureGroup: getActiveFeatureGroup(store),
    allFilterGroups,
  };
};

const mapDispatchToProps = {
  loadFeaturesSetupFeatures,
  clearFeaturesSetup,
  featuresSetupSetSearchTerm,
  setFeatureCreatorFeatureGroup,
  getCustomerInfo,
  clearInitialValues,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default modifyPageLayoutComponents({
  pageHeader: connector(FeaturesSetupHeader),
  content: connector(FeaturesSetup),
  pageFooter: connector(FeaturesSetupFooter),
});
